import { render, staticRenderFns } from "./NumericInputCustom.vue?vue&type=template&id=0b80a70c&"
import script from "./NumericInputCustom.vue?vue&type=script&lang=js&"
export * from "./NumericInputCustom.vue?vue&type=script&lang=js&"
import style0 from "./NumericInputCustom.vue?vue&type=style&index=0&id=0b80a70c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports